import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, InformationModal } from "@impero-com/ui";

import { useBulkDeleteTestingControlMutation } from "./queries/useTestingControlBulkDeleteMutation";

interface DeleteTestingControlsModalProps {
    testingControlIds: string[];
    open: boolean;
    onClose: () => void;
    deselectAll: () => void;
}

export function DeleteTestingControlsModal({
    testingControlIds,
    open,
    onClose,
    deselectAll,
}: DeleteTestingControlsModalProps) {
    const { isPending, mutateAsync } = useBulkDeleteTestingControlMutation();
    const { t } = useTranslation();

    const onClickOk = async () => {
        await mutateAsync({ data: testingControlIds });
        deselectAll();
        onClose();
    };

    return (
        <InformationModal
            open={open}
            onClose={onClose}
            type="error"
            icon="delete"
            title={t("ControlTesting_Action_DeleteTestingControl")}
            footer={
                <>
                    <Button onClick={onClose}>{t("Cancel")}</Button>
                    <Button
                        variant="destructive"
                        loading={isPending}
                        onClick={() => {
                            onClickOk();
                        }}
                    >
                        {t("Delete")}
                    </Button>
                </>
            }
        >
            <p>{t("ControlTesting_Action_DeleteTestingControlConfirmation")}</p>
        </InformationModal>
    );
}
